import React from 'react';
import { Briefcase, Shield, Users } from 'lucide-react';

const Leadership = () => {
  const executives = [
    {
      name: 'Dr. Jay Thomas',
      title: 'CEO',
      credentials: 'Doctor of Business Administration',
      initial: 'JT',
      color: 'bg-gradient-to-br from-cyan-500 to-blue-600'
    },
    {
      name: 'Dr. Charles Needham',
      title: 'CAO',
      credentials: 'Doctor of Business Administration',
      experience: '30 years teaching experience',
      initial: 'CN',
      color: 'bg-gradient-to-br from-purple-500 to-pink-600'
    },
    {
      name: 'Rakesh Akawaldi',
      title: 'Instructor',
      credentials: 'IT Technology School Graduate',
      initial: 'RA',
      color: 'bg-gradient-to-br from-teal-500 to-green-600'
    }
  ];

  const boardMembers = [
    {
      name: 'Dr. Daniel Desrivieres',
      title: 'Chief',
      credentials: 'OD, MD',
      experience: '30 years successful practice in the medical field',
      initial: 'DD',
      color: 'bg-gradient-to-br from-blue-500 to-indigo-600'
    },
    {
      name: 'Jasmine Jones',
      title: 'Treasurer',
      credentials: 'Director, Fortune 5000 Company',
      initial: 'JJ',
      color: 'bg-gradient-to-br from-pink-500 to-rose-600'
    },
    {
      name: 'Dr. Maria Needham',
      title: 'Secretary',
      credentials: 'Doctor of Business Administration',
      experience: '30 years experience in Educational Field',
      initial: 'MN',
      color: 'bg-gradient-to-br from-amber-500 to-orange-600'
    }
  ];

  const LeaderCard = ({ person, Icon }) => (
    <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:transform hover:-translate-y-2 border border-gray-100">
      <div className="flex items-start gap-4 mb-4">
        <div className={`w-16 h-16 rounded-xl ${person.color} flex items-center justify-center text-white text-lg font-bold shadow-lg flex-shrink-0`}>
          {person.initial}
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-900 mb-1">{person.name}</h3>
          <div className="flex items-center gap-2 mb-2">
            <Icon size={16} className="text-cyan-500" />
            <span className="text-cyan-600 font-semibold text-sm">{person.title}</span>
          </div>
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-gray-700 font-medium text-sm">{person.credentials}</p>
        {person.experience && (
          <p className="text-gray-600 text-sm">{person.experience}</p>
        )}
      </div>
    </div>
  );

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Leadership Team
          </h2>
          <div className="section-underline"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the experienced professionals leading The 317 Foundation's mission
          </p>
        </div>

        <div className="mb-16">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center shadow-lg">
              <Briefcase className="text-white" size={24} />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Executive Leadership</h3>
              <p className="text-gray-600 text-sm">Guiding our strategic vision and operations</p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {executives.map((person, index) => (
              <LeaderCard key={index} person={person} Icon={Briefcase} />
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-400 to-pink-500 flex items-center justify-center shadow-lg">
              <Shield className="text-white" size={24} />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Board of Directors</h3>
              <p className="text-gray-600 text-sm">Providing governance and strategic oversight</p>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {boardMembers.map((person, index) => (
              <LeaderCard key={index} person={person} Icon={Shield} />
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-4 px-8 py-6 bg-gradient-to-r from-cyan-50 to-purple-50 rounded-2xl border-2 border-cyan-100">
            <Users className="text-cyan-600" size={40} />
            <div className="text-left">
              <div className="text-gray-900 font-bold text-xl mb-1">100+ Combined Years of Experience</div>
              <div className="text-gray-600">Committed to empowering the next generation of tech leaders</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Leadership;
